import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/rintisan.png")